import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '[data-component="marquee-hero"]' ).each( function( index, element ) {
        const thumbnailEl = element.querySelector( '.marquee-hero__thumbnail-splide' );
        const imageEl = element.querySelector( '.marquee-hero__image-splide' );
        const marqueeEl = element.querySelector( '.marquee-hero__marquee-splide' );
        const prevBtn = element.querySelector( '.js-room-prev' );
        const nextBtn = element.querySelector( '.js-room-next' );

        if ( thumbnailEl && imageEl ) {
          const imageSplide = new Splide( imageEl, {
            type: 'loop',
            arrows: false,
            pagination: false,
          } );

          const thumbnailSplide = new Splide( thumbnailEl, {
            type: 'slide',
            perPage: 5,
            gap: '0.5rem',
            arrows: false,
            pagination: false,
            isNavigation: true,
            breakpoints: {
              728: {
                perPage: 3,
              },
              1024: {
                perPage: 4,
              },
            },
          } );

          imageSplide.sync( thumbnailSplide );
          imageSplide.mount();
          thumbnailSplide.mount();

          if ( prevBtn ) {
            prevBtn.addEventListener( 'click', () => thumbnailSplide.go( '<' ) );
          }
          if ( nextBtn ) {
            nextBtn.addEventListener( 'click', () => thumbnailSplide.go( '>' ) );
          }
        }

        if ( marqueeEl ) {
          const marqueeList = marqueeEl.querySelector( '.splide__list' );
          const originalSlides = Array.from( marqueeList.querySelectorAll( '.splide__slide' ) );
          const sectionWidth = element.offsetWidth;
          const doubleSectionWidth = sectionWidth * 2;
          let totalWidth = originalSlides.reduce( ( sum, slide ) => sum + slide.offsetWidth, 0 );
          let iterations = 0;

          while ( totalWidth < doubleSectionWidth && iterations < 10 ) {
            originalSlides.forEach( function( slide ) {
              const clone = slide.cloneNode( true );
              marqueeList.appendChild( clone );
              totalWidth += slide.offsetWidth;
            } );
            iterations++;
          }

          const marqueeSplide = new Splide( marqueeEl, {
            type: 'loop',
            drag: 'free',
            arrows: false,
            pagination: false,
            autoWidth: true,
            gap: '1.25rem',
            autoScroll: {
              speed: .75,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          marqueeSplide.mount( {AutoScroll} );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'marquee-hero', COMPONENT );
} )( app );
